import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { engagementSurveys, type ProgramSurveySummary } from 'services/api/engagementSurveysClient';
import 'pages/ProgramSurveys/ProgramSurveys.css';

export function ProgramSurveyCard() {
  const [surveys, setSurveys] = useState<ProgramSurveySummary[]>([]);
  const generation = useRef(0);
  useEffect(() => {
    let mounted = true;
    const refresh = async () => {
      const request = ++generation.current;
      try {
        const rows = await engagementSurveys.list();
        if (mounted && request === generation.current) setSurveys(rows);
      } catch { /* The check-in page provides explicit recovery; no empty-state claim here. */ }
    };
    void refresh();
    window.addEventListener('focus', refresh);
    return () => { mounted = false; generation.current += 1; window.removeEventListener('focus', refresh); };
  }, []);
  if (!surveys.length) return null;
  const available = surveys.filter((survey) => survey.status === 'available');
  const next = available[0];
  return (
    <Link className="program-survey-home-card" to={next ? `/program-surveys?survey=${encodeURIComponent(next.id)}` : '/program-surveys'}>
      <div><strong>Program check-ins</strong><span>{available.length ? `${available.length} ready to complete` : 'View your program check-ins'}</span></div>
      <ArrowUpRight size={20} aria-hidden="true" />
    </Link>
  );
}
